import type { TableQuery } from 'ab-common/dataStructures/tableQuery';

import baseRoute from '../baseRoute';

export type * from './viewModel';

type RouteDefinition = `${typeof baseRoute}/list/inProgress${`?query=${string}` | ''}`;

export const ROUTE: RouteDefinition = `${baseRoute}/list/inProgress`;

export const URL = (tableRequestModel: TableQuery): RouteDefinition => `${baseRoute}/list/inProgress?query=${encodeURIComponent((JSON.stringify(tableRequestModel)))}`;
